import React from 'react';
import {CalculationLoader, Table} from '@/web-components';
import Util from '../../../../shared/util/util';
import {GLOBAL_FILTER_FIELD, GLOBAL_FILTER_OPERATOR} from '../../../../../constants';
import {getQueryRenderer} from '../TimeRegistrationReportPageUtil';
import {idFromGlobalId} from '../../../../shared/util/GlobalIdUtil';
import {hasFeatureFlag} from '../../../../shared/util/FeatureUtil';

export const getTaskRow = (
	data,
	intl,
	groupIndex,
	searchQuery,
	groupings,
	enabledColumns,
	hasNextPage,
	fetchMore,
	nextLevelProps,
	currency,
	reportId,
	sharedId,
	customFieldColumnCount,
	customFieldKeys
) => {
	const getColumns = task => {
		const hasAccessToTask = task.hasAccessToTask;
		const formattedPrice = intl.formatNumber(task.timeRegTotals?.totalPrice, {format: 'always_two_decimal'});
		const formattedCost = intl.formatNumber(task.timeRegTotals?.totalCost, {format: 'always_two_decimal'});
		const noAccessTask = idFromGlobalId(task.taskId) === -1;
		const name = task.noTask
			? intl.formatMessage({id: 'time_reg_report.no_task'})
			: noAccessTask
			? intl.formatMessage({id: 'time_reg_report.no_tasks_access'})
			: task.name;
		const phaseName = task.phase?.name;
		const columns = [
			<Table.Column>
				<span>{name}</span>
			</Table.Column>,
			<Table.Column />,
			<Table.Column>{phaseName}</Table.Column>,
			...(hasFeatureFlag('deliverables') ? [<Table.Column />] : []),
			<Table.Column />,
			<Table.Column>{Util.convertMinutesToFullHour(task.timeRegTotals?.totalTimeRegistered, intl, true)}</Table.Column>,
			<Table.Column>
				{Util.convertMinutesToFullHour(task.timeRegTotals?.totalBillableRegistered, intl, true)}
			</Table.Column>,
			<Table.Column>
				{Util.convertMinutesToFullHour(task.timeRegTotals?.totalNonBillableRegistered, intl, true)}
			</Table.Column>,
			<Table.Column />,
			<Table.Column />,
			<Table.Column />,
			<Table.Column />,
			<Table.Column />,
			<Table.Column />,
			<Table.Column />,
			<Table.Column>
				<span>
					{hasAccessToTask ? (
						formattedPrice ? (
							Util.GetFormattedCurrencySymbol(currency, formattedPrice)
						) : (
							<CalculationLoader />
						)
					) : (
						'-'
					)}
				</span>
			</Table.Column>,
			<Table.Column>
				<span>
					{hasAccessToTask ? (
						formattedCost ? (
							Util.GetFormattedCurrencySymbol(currency, formattedCost)
						) : (
							<CalculationLoader />
						)
					) : (
						'-'
					)}
				</span>
			</Table.Column>,
			<Table.Column />,
			<Table.Column />,
		];

		for (let i = 0; i < customFieldColumnCount; i++) {
			columns.push(<Table.Column />);
		}

		return columns;
	};

	return (
		<Table.Rows
			data={data}
			canExpand={true}
			autoload={hasNextPage && groupIndex === 1}
			loadMore={hasNextPage ? fetchMore : false}
			{...nextLevelProps}
		>
			{({rowData, tableColumnsProps, nextLevelProps, expanded}) => {
				const filterField =
					rowData.noTask === true ? GLOBAL_FILTER_FIELD.NON_TASK_TIME_REG : GLOBAL_FILTER_FIELD.TASK_TIME_REG;
				return (
					<>
						<Table.Row canExpandRow={rowData.canExpand} {...tableColumnsProps}>
							{getColumns(rowData)}
						</Table.Row>
						{expanded &&
							getQueryRenderer(
								null,
								groupings,
								searchQuery,
								groupIndex,
								enabledColumns,
								{field: filterField, operator: GLOBAL_FILTER_OPERATOR.IS, value: [rowData.taskId]},
								nextLevelProps,
								currency,
								reportId,
								sharedId,
								customFieldColumnCount,
								customFieldKeys
							)}
					</>
				);
			}}
		</Table.Rows>
	);
};
